<template>
  <div>
    <template v-if="externalContexts.length">
      <div v-for="(externalContext, index) in externalContexts" :key="index">
        <ClientCard :content="externalContext" :save-customer="saveCustomer" :disabled="true" :title="getTitle(index)" />
      </div>
    </template>
    <template v-else>
      <v-card class="mx-4 my-4" elevation="0" light outlined>
        <v-card-text class="d-flex justify-center grey lighten-4">
          <div class="col-6 py-1 grey--text text--darken-4">
            <p class="text-body-1 mb-2">
              Ce client n'a pas de compte secondaire lié à son compte principal.
            </p>
            <p class="text-body-1 mb-2">
              S'il possède un compte partenaire non-lié à son compte principal,
              <em>ex: CNAS/CNOUS/CGOS...</em>
            </p>
            <p class="text-body-1 mb-0">
              Il lui suffit de se connecter à son compte partenaire pour que ses comptes soient automatiquement liés.
            </p>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import ClientCard from '@/components/profile/ClientCard.vue';

export default {
  name: 'ProfileSpeedboatIdentities',
  components: { ClientCard },
  props: {
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    }
  },
  computed: {
    externalContexts () {
      const externalContexts = this.content.externalContextsData ? Object.keys(this.content.externalContextsData) : [];

      if (!externalContexts.length) {
        return [];
      }
      return externalContexts.filter(key => !!this.content.externalContextsData[key]).map(context => ({ ...this.content, ...this.content.externalContextsData[context], externalContextKey: context }));
    }
  },
  methods: {
    getTitle (contextId) {
      return `Identité ${Object.keys(this.content.externalContextsData)[contextId].toUpperCase()}`;
    }
  }
};
</script>
